(function () {
    'use strict';
  
    var module = angular.module('uwAgenda.global');
    module.controller('HeaderDevelopmentWarningController', [
      '$location',
      HeaderDevelopmentWarningControllerFN
    ]);
  
    /* Header Controller */
    function HeaderDevelopmentWarningControllerFN(
      $location
    ) {
      var vm = this;
      
      vm.isDevelopment = false;
      if ($location.host().indexOf('dev.myorganizer.online') !== -1
      || $location.host().indexOf('127.0.0.1') !== -1
      || $location.host().indexOf('localhost') !== -1)
      {
        vm.isDevelopment = true;
        const doc = document.documentElement;
        doc.style.setProperty('--fixed-header-height', '80px');        
        doc.style.setProperty('--fixed-mobile-header-height', '130px');
      }
    vm.isQa = false;
    if ($location.host().indexOf('qa.myorganizer.online') !== -1)
    {
        vm.isQa = true;
        const doc = document.documentElement;
        doc.style.setProperty('--fixed-header-height', '80px');
        doc.style.setProperty('--fixed-mobile-header-height', '130px');
    }
      
    }
  })();
  